
/* Flipper Image Randomiser */
document.addEventListener('DOMContentLoaded', () => {
  const eggFrontUrls = [
    'https://cdn.shopify.com/s/files/1/0043/1548/0177/files/FRONT_01.png?v=1782687834',
    'https://cdn.shopify.com/s/files/1/0043/1548/0177/files/FRONT_02.png?v=1782687834',
    'https://cdn.shopify.com/s/files/1/0043/1548/0177/files/FRONT_03.png?v=1782687834',
    'https://cdn.shopify.com/s/files/1/0043/1548/0177/files/FRONT_04.png?v=1782687834',
    'https://cdn.shopify.com/s/files/1/0043/1548/0177/files/FRONT_05.png?v=1782687834',
     'https://cdn.shopify.com/s/files/1/0043/1548/0177/files/FRONT_01.png?v=1782687834',
    'https://cdn.shopify.com/s/files/1/0043/1548/0177/files/FRONT_02.png?v=1782687834',
    'https://cdn.shopify.com/s/files/1/0043/1548/0177/files/FRONT_03.png?v=1782687834',
    'https://cdn.shopify.com/s/files/1/0043/1548/0177/files/FRONT_04.png?v=1782687834',
    'https://cdn.shopify.com/s/files/1/0043/1548/0177/files/FRONT_05.png?v=1782687834'
  ];

  function shuffle(arr) {
    const copy = [...arr];
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  }

  function shuffleAvoiding(arr, avoid) {
    let result;
    let attempts = 0;
    do {
      result = shuffle(arr);
      attempts++;
    } while (result[0] === avoid && attempts < 20);
    return result;
  }

  const allEggs = document.querySelectorAll('[data-egg-front]');
  const groups = new Map();

  allEggs.forEach(img => {
    const parent = img.closest('.flip-container').parentElement;
    if (!groups.has(parent)) groups.set(parent, []);
    groups.get(parent).push(img);
  });

  let lastUrl = null;

  groups.forEach(imgs => {
    const order = shuffleAvoiding(eggFrontUrls, lastUrl);
    imgs.forEach((img, i) => {
      img.src = order[i];
    });
    lastUrl = order[order.length - 1];
  });
});

// =============================================================================
// Easter Flipper — easter.js
// Flow:
//   1. Egg clicked → weighted reward picked → egg flips → spinner shows
//   2a. discount only        → clear previous bonus products → redirect /discount/CODE
//   2b. product_with_discount → clear previous bonus products → add new product → redirect /discount/CODE
//   3. Page reloads with discount active → cart opens automatically
// =============================================================================


(function () {
  'use strict';

  // ─── Config ─────────────────────────────────────────────────────────────────
  const CDN          = 'https://cdn.shopify.com/s/files/1/0043/1548/0177/files/';
  const CACHE_BUST   = '?v=1782687834';
  const FLIP_DELAY   = 900;

  // ─── Offers ─────────────────────────────────────────────────────────────────
  const EGG_OFFERS = {
    blue: [
      { img: 'OFFER_02.png',      type: 'discount',              code: 'XMAS20'                                            },
      { img: 'OFFER_01.png',      type: 'discount',              code: 'XMAS15'                                            },
      { img: 'OFFER_04.png',     type: 'product_with_discount', productId: '52963146203500', discountCode: 'XMASOIL'      },
      { img: 'OFFER_03.png', type: 'product_with_discount', productId: '53897942761836', discountCode: 'XMASMIST'   },
      { img: 'OFFER_05.png',  type: 'product_with_discount', productId: '42579393118396', discountCode: 'XMASLOTION'    }
    ],
    yellow: [
      { img: 'OFFER_02.png',      type: 'discount',              code: 'XMAS20'                                            },
      { img: 'OFFER_01.png',      type: 'discount',              code: 'XMAS15'                                            },
      { img: 'OFFER_04.png',     type: 'product_with_discount', productId: '52963146203500', discountCode: 'XMASOIL'      },
      { img: 'OFFER_03.png', type: 'product_with_discount', productId: '53897942761836', discountCode: 'XMASMIST'   },
      { img: 'OFFER_05.png',  type: 'product_with_discount', productId: '42579393118396', discountCode: 'XMASLOTION'    }
    ],
    pink: [
      { img: 'OFFER_03.png', type: 'product_with_discount', productId: '53897942761836', discountCode: 'XMASMIST'   },
      { img: 'OFFER_04.png',     type: 'product_with_discount', productId: '52963146203500', discountCode: 'XMASOIL'      },
      { img: 'OFFER_02.png',      type: 'discount',              code: 'XMAS20'                                            },
      { img: 'OFFER_01.png',      type: 'discount',              code: 'XMAS15'                                    },
      { img: 'OFFER_05.png',  type: 'product_with_discount', productId: '42579393118396', discountCode: 'XMASLOTION'    }
    ]
  };

  // All known bonus variant IDs — used to sweep the cart before applying a new offer
  const BONUS_VARIANT_IDS = [
    '52963146203500',  // OIL
    '53897942761836',  // MIST
    '42579393118396'   // LOTION
  ];

  // ─── DOM refs — cached once ──────────────────────────────────────────────────
  const spinnerWrapper = document.getElementById('egg-spinner');
  const spinnerImg     = document.getElementById('egg-spinner-img');
  const eggContainers  = document.querySelectorAll('.flip-container');

  // ─── Spinner ─────────────────────────────────────────────────────────────────
  function showSpinner(imgSrc) {
    if (spinnerImg && imgSrc) spinnerImg.src = imgSrc;
    if (spinnerWrapper) spinnerWrapper.style.display = 'flex';
  }

  function hideSpinner() {
    if (spinnerWrapper) spinnerWrapper.style.display = 'none';
  }

  // ─── Build the offer image URL — single source of truth, no cache busting per click ──
  function offerImgUrl(img) {
    return `${CDN}${img}${CACHE_BUST}`;
  }

  // ─── Preload reward images — only for colours actually present on this page ──────
  // (skip preloading colours that aren't rendered, deduplicate across colours)
  const presentColors = new Set(
    Array.from(eggContainers).map(el => el.dataset.color)
  );
  const preloaded = new Set();
  presentColors.forEach(color => {
    (EGG_OFFERS[color] || []).forEach(({ img }) => {
      if (preloaded.has(img)) return;
      preloaded.add(img);
      new Image().src = offerImgUrl(img);
    });
  });

  // ─── Weighted reward picker ───────────────────────────────────────────────────
  function pickWeightedReward(offers, discountWeight = 0.65) {
    const discounts = offers.filter(o => o.type === 'discount');
    const products  = offers.filter(o => o.type === 'product_with_discount');
    const roll      = Math.random();

    console.log(`[Flipper] 🎲 roll: ${roll.toFixed(4)} (discount threshold: ${discountWeight})`);

    if (roll < discountWeight && discounts.length) {
      console.log('[Flipper] 🎁 picked: discount');
      return discounts[Math.floor(Math.random() * discounts.length)];
    }
    if (products.length) {
      console.log('[Flipper] 🎁 picked: product_with_discount');
      return products[Math.floor(Math.random() * products.length)];
    }
    console.log('[Flipper] 🎁 picked: discount (fallback)');
    return discounts[Math.floor(Math.random() * discounts.length)] || null;
  }

  // ─── Cart helpers ─────────────────────────────────────────────────────────────
  function cartPost(endpoint, body) {
    return fetch(endpoint, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(body)
    }).then(res => {
      if (!res.ok) throw new Error(`Cart request failed: ${res.status}`);
      return res.json();
    });
  }

  function clearPreviousBonusProduct() {
    return new Promise((resolve) => {
        const prev = JSON.parse(sessionStorage.getItem('bonusProduct') || 'null');
        if (!prev) return resolve();

        cartPost('/cart/change.js', { id: prev.productId, quantity: 0 })
            .then(() => console.log(`[Flipper] Removed previous bonus ${prev.productId}`))
            .catch(err => console.warn('[Flipper] Failed to remove previous bonus:', err))
            .finally(() => {
                sessionStorage.removeItem('bonusProduct');
                sessionStorage.removeItem('activeDiscountCode');
                resolve();
            });
    });
}

function redirectWithDiscount(code) {
    const returnTo = window.location.pathname + window.location.search;
    sessionStorage.setItem('openCartAfterDiscount', 'true');
    setTimeout(() => {
        window.location.href = `/discount/${code}?redirect=${encodeURIComponent(returnTo)}`;
    }, 1000);
}

function applyOffer(offer) {
    clearPreviousBonusProduct().then(() => {

        // Discount only
        if (offer.type === 'discount') {
            sessionStorage.setItem('activeDiscountCode', offer.code);
            redirectWithDiscount(offer.code);
        }

        // Product + discount
        else if (offer.type === 'product_with_discount') {
            cartPost('/cart/add.js', { id: offer.productId, quantity: 1 })
                .then(() => {
                    sessionStorage.setItem('activeDiscountCode', offer.discountCode);
                    sessionStorage.setItem('bonusProduct', JSON.stringify({
                        productId: offer.productId,
                        discountCode: offer.discountCode
                    }));
                    redirectWithDiscount(offer.discountCode);
                })
                .catch(err => {
                    console.warn('[Flipper] Cart add failed:', err);
                    alert('Something went wrong adding your reward. Please try again.');
                    hideSpinner();
                });
        }
    });
}

  // ─── Egg flip + click handler ─────────────────────────────────────────────────
  eggContainers.forEach(container => {
    container.addEventListener('click', () => {
      if (container.classList.contains('flipped')) return;

      const offers = EGG_OFFERS[container.dataset.color];
      const chosen = pickWeightedReward(offers);
      if (!chosen) return;

      const backImg    = container.querySelector('.back');
      const backImgUrl = offerImgUrl(chosen.img);

      const proceed = () => {
        container.classList.add('flipped');
        setTimeout(() => {
          showSpinner(backImgUrl);

          // Show what they won in the spinner text
          const spinnerText = document.getElementById('egg-spinner-text');
          if (spinnerText) {
            if (chosen.type === 'discount') {
              const pct = chosen.code.replace(/\D/g, '');
              spinnerText.textContent = `You won ${pct}% off!`;
            } else {
              spinnerText.innerHTML = `You won a free gift!<br><span style="font-size:12px; opacity:0.7;">Min Spend $60+</span>`;
            }
          }

          applyOffer(chosen);
        }, FLIP_DELAY);
      };

      // Same URL as preload — hits browser cache instead of re-downloading
      backImg.onload  = proceed;
      backImg.onerror = proceed;
      backImg.src     = backImgUrl;
    });
  });

  // ─── Page load: open cart after discount redirect ─────────────────────────────
  window.addEventListener('load', () => {
    if (sessionStorage.getItem('openCartAfterDiscount') !== 'true') return;
    sessionStorage.removeItem('openCartAfterDiscount');

    // Touch the cart so Shopify recalculates with the new discount, then open
    cartPost('/cart/update.js', {
      attributes: { _egg_hunt_ts: Date.now().toString() }
    })
    .catch(() => {})
    .finally(() => {
      if (window.UpCart && typeof UpCart.refreshCart === 'function') UpCart.refreshCart();
      setTimeout(() => {
        if (window.UpCart && typeof UpCart.openCart === 'function') {
          UpCart.openCart();
        } else {
          const btn = document.querySelector('.header__icon--cart');
          if (btn) btn.click();
        }
      }, 400);
    });
  });

  // ─── Cart integrity: discount removal watcher ──────────────────────────────
  // NO polling. Only reacts when the customer explicitly clicks the X on the
  // discount tag in UpCart's UI. Watches for the tag element disappearing.

  function onDiscountRemovedByCustomer() {
    const bonusData = JSON.parse(sessionStorage.getItem('bonusProduct') || 'null');
    if (!bonusData) {
      // Was a discount-only code — just clear session
      sessionStorage.removeItem('activeDiscountCode');
      console.log('[Flipper] Discount removed by customer. Session cleared.');
      return;
    }

    // Bonus product needs removing from cart — remove by id, no need to fetch first
    console.log('[Flipper] Discount removed by customer — removing bonus product.');
    cartPost('/cart/change.js', { id: bonusData.productId, quantity: 0 })
      .then(() => {
        if (window.UpCart && typeof UpCart.refreshCart === 'function') UpCart.refreshCart();
        console.log('[Flipper] Bonus product removed.');
      })
      .catch(err => console.warn('[Flipper] Failed to remove bonus product:', err))
      .finally(() => {
        sessionStorage.removeItem('bonusProduct');
        sessionStorage.removeItem('activeDiscountCode');
      });
  }

  // Watch for UpCart discount tag being removed from the DOM
  function watchForDiscountRemoval() {
    // V2 discount tags live inside the cart summary
    const target = document.querySelector('.upcart-public-cart-summary__slide-codes')
                || document.querySelector('.upcart-public-cart-summary');
    if (!target) {
      // UpCart not rendered yet — retry
      setTimeout(watchForDiscountRemoval, 2000);
      return;
    }

    let hadTag = !!target.querySelector('.upcart-public-component-tag');

    new MutationObserver(() => {
      const hasTag = !!target.querySelector('.upcart-public-component-tag');

      // Tag disappeared — customer removed the discount
      if (hadTag && !hasTag) {
        onDiscountRemovedByCustomer();
      }
      hadTag = hasTag;
    }).observe(target, { childList: true, subtree: true });

    console.log('[Flipper] Watching for discount removal in UpCart UI.');
  }

  document.addEventListener('DOMContentLoaded', watchForDiscountRemoval);

})();